const SENSITIVE_KEY_RE = /(token|secret|password|private|signature|authorization|bearer|key|certificatePem|privateKey)/i;

export function redactSensitive(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map((item) => redactSensitive(item));
  }
  if (!value || typeof value !== "object") {
    return value;
  }
  return Object.fromEntries(
    Object.entries(value).map(([key, entry]) => [
      key,
      SENSITIVE_KEY_RE.test(key) ? "[redacted]" : redactSensitive(entry)
    ])
  );
}

export function formatRedactedJson(value: unknown) {
  return JSON.stringify(redactSensitive(value), null, 2);
}
